export const BANK_TRANSFER = 7;
export const CHEQUE = 3;
export const CREDIT = 10;
export const LOCOFAST_ACCOUNT = 9;
export const PAYMENT_GATEWAY = 8;
export const UPI = 2;
export const LC = 12;
export const TT_LC = 11;
export const DEBIT = 13;
export const VPA_UPI = 6;
export const BLACK_SOIL = 20;
export const STRIDE = 25;
export const LOCOFAST = 30;
export const MUTHOOT_FINCORP = 35;
export const FINANCE_121 = 40;
export const INDIFI = 45;
export const BLACK_SOIL_100 = 50;
export const STRIDE_100 = 55;
export const MINTIFI = 60;
export const OXYZO = 65;
export const TDS = 14;
export const CREDIT_NOTE_DEBIT_NOTE = 15;
export const LEDGER_SETTLEMENT = 16;
export const CASH_DISCOUNT = 17;
export const CREDIT_LIMIT = 18;

export const PAYMENT_MODE = {
  [BANK_TRANSFER]: 'Bank Transfer',
  [CHEQUE]: 'Cheque',
  [CREDIT]: 'Credit note',
  [LOCOFAST_ACCOUNT]: 'Locofast Account',
  [PAYMENT_GATEWAY]: 'Payment Gateway',
  [UPI]: 'UPI',
  [TT_LC]: 'TT + LC',
  [LC]: 'LC',
  [DEBIT]: 'Debit',
  [VPA_UPI]: 'VPA UPI',
  [BLACK_SOIL]: 'Black Soil',
  [STRIDE]: 'Stride',
  [LOCOFAST]: 'Locofast',
  [MUTHOOT_FINCORP]: 'Muthoot FinCorp Limited',
  [FINANCE_121]: '121 Finance',
  [INDIFI]: 'Indifi',
  [BLACK_SOIL_100]: 'Black Soil 100%',
  [STRIDE_100]: 'Stride 100%',
  [MINTIFI]: 'Mintifi',
  [OXYZO]: 'Oxyzo',
  [TDS]: 'TDS',
  [CREDIT_NOTE_DEBIT_NOTE]: 'Credit Note - Debit Note',
  [LEDGER_SETTLEMENT]: 'Ledger Settlement',
  [CASH_DISCOUNT]: 'Cash Discount',
  [CREDIT_LIMIT]: 'Credit Limit'
};

export const CUSTOMER_PAYMENT_TYPE = {
  ADVANCED: 10,
  FOLLOW_UP: 20
};

export const REQUEST_PAYMENT_TYPE_NAME = {
  [CUSTOMER_PAYMENT_TYPE.ADVANCED]: 'Advanced',
  [CUSTOMER_PAYMENT_TYPE.FOLLOW_UP]: 'Follow up'
};

export const REQUEST_PAYMENT_TYPE_NAME_REVERSE = {
  [REQUEST_PAYMENT_TYPE_NAME[CUSTOMER_PAYMENT_TYPE.ADVANCED]]: CUSTOMER_PAYMENT_TYPE.ADVANCED,
  [REQUEST_PAYMENT_TYPE_NAME[CUSTOMER_PAYMENT_TYPE.FOLLOW_UP]]: CUSTOMER_PAYMENT_TYPE.FOLLOW_UP
};

export const CUSTOMER_REQUEST_PAYMENT_TYPE = [
  {
    paymentType: REQUEST_PAYMENT_TYPE_NAME[CUSTOMER_PAYMENT_TYPE.ADVANCED],
    id: CUSTOMER_PAYMENT_TYPE.ADVANCED
  },
  {
    paymentType: REQUEST_PAYMENT_TYPE_NAME[CUSTOMER_PAYMENT_TYPE.FOLLOW_UP],
    id: CUSTOMER_PAYMENT_TYPE.FOLLOW_UP
  }
];

export const PAYMENT_MODE_REVERSE = {
  [PAYMENT_MODE[BANK_TRANSFER]]: BANK_TRANSFER,
  [PAYMENT_MODE[CHEQUE]]: CHEQUE,
  [PAYMENT_MODE[DEBIT]]: DEBIT,
  [PAYMENT_MODE[LOCOFAST_ACCOUNT]]: LOCOFAST_ACCOUNT,
  [PAYMENT_MODE[UPI]]: UPI,
  [PAYMENT_MODE[CREDIT]]: CREDIT,
  [PAYMENT_MODE[BLACK_SOIL]]: BLACK_SOIL,
  [PAYMENT_MODE[STRIDE]]: STRIDE,
  [PAYMENT_MODE[LOCOFAST]]: LOCOFAST,
  [PAYMENT_MODE[MUTHOOT_FINCORP]]: MUTHOOT_FINCORP,
  [PAYMENT_MODE[FINANCE_121]]: FINANCE_121,
  [PAYMENT_MODE[INDIFI]]: INDIFI,
  [PAYMENT_MODE[BLACK_SOIL_100]]: BLACK_SOIL_100,
  [PAYMENT_MODE[STRIDE_100]]: STRIDE_100,
  [PAYMENT_MODE[MINTIFI]]: MINTIFI,
  [PAYMENT_MODE[OXYZO]]: OXYZO,
  [PAYMENT_MODE[TDS]]: TDS,
  [PAYMENT_MODE[CREDIT_NOTE_DEBIT_NOTE]]: CREDIT_NOTE_DEBIT_NOTE,
  [PAYMENT_MODE[LEDGER_SETTLEMENT]]: LEDGER_SETTLEMENT,
  [PAYMENT_MODE[CASH_DISCOUNT]]: CASH_DISCOUNT,
  [PAYMENT_MODE[CREDIT_LIMIT]]: CREDIT_LIMIT
};

export const PAYMENT_MODE_OPTIONS_FORM_DOMESTIC = [
  {
    paymentMode: PAYMENT_MODE[BANK_TRANSFER],
    id: BANK_TRANSFER
  },
  {
    paymentMode: PAYMENT_MODE[CHEQUE],
    id: CHEQUE
  },
  {
    paymentMode: PAYMENT_MODE[CREDIT],
    id: CREDIT
  },
  {
    paymentMode: PAYMENT_MODE[LOCOFAST_ACCOUNT],
    id: LOCOFAST_ACCOUNT
  },
  {
    paymentMode: PAYMENT_MODE[UPI],
    id: UPI
  },
  {
    paymentMode: PAYMENT_MODE[CREDIT_LIMIT],
    id: CREDIT_LIMIT
  }
];
export const PAYMENT_MODE_OPTIONS_FORM_INTERNATIONAL = [
  {
    paymentMode: PAYMENT_MODE[LC],
    id: LC
  },
  {
    paymentMode: PAYMENT_MODE[TT_LC],
    id: TT_LC
  }
];
export const CREDIT_NOTE_OPTIONS = [
  {
    paymentMode: PAYMENT_MODE[BLACK_SOIL],
    id: BLACK_SOIL
  },
  {
    paymentMode: PAYMENT_MODE[STRIDE],
    id: STRIDE
  },
  {
    paymentMode: PAYMENT_MODE[LOCOFAST],
    id: LOCOFAST
  },
  {
    paymentMode: PAYMENT_MODE[MUTHOOT_FINCORP],
    id: MUTHOOT_FINCORP
  },
  {
    paymentMode: PAYMENT_MODE[FINANCE_121],
    id: FINANCE_121
  },
  {
    paymentMode: PAYMENT_MODE[INDIFI],
    id: INDIFI
  },
  {
    paymentMode: PAYMENT_MODE[BLACK_SOIL_100],
    id: BLACK_SOIL_100
  },
  {
    paymentMode: PAYMENT_MODE[STRIDE_100],
    id: STRIDE_100
  },
  {
    paymentMode: PAYMENT_MODE[MINTIFI],
    id: MINTIFI
  },
  {
    paymentMode: PAYMENT_MODE[OXYZO],
    id: OXYZO
  }
];

export const PENDING = 2;
export const RECEIVED = 3;
export const CANCELLED = 4;

export const CREDIT_STATUS = {
  AWAITED: 1,
  ASSIGNED: 2
};

export const PAYMENT_STATUS = {
  1: '',
  [PENDING]: 'Pending',
  [RECEIVED]: 'Received',
  [CANCELLED]: 'Cancelled',
  5: ''
};

export const PAYMENT_FILTERS_PROVISIONAL = [
  {
    text: PAYMENT_MODE[UPI],
    value: UPI
  },
  {
    text: PAYMENT_MODE[LC],
    value: LC
  },
  {
    text: PAYMENT_MODE[TT_LC],
    value: TT_LC
  }
];

export const PAYMENT_FILTERS_HISTORY = [
  {
    text: PAYMENT_MODE[UPI],
    value: UPI
  },
  {
    text: PAYMENT_MODE[BANK_TRANSFER],
    value: BANK_TRANSFER
  },
  {
    text: PAYMENT_MODE[CREDIT],
    value: CREDIT
  },
  {
    text: PAYMENT_MODE[LC],
    value: LC
  },
  {
    text: PAYMENT_MODE[TT_LC],
    value: TT_LC
  }
];

export const REQUEST_TAB_TYPE_ORDERS = {
  provisionalOrders: '1',
  history: '2',
  invoices: '3'
};
export const SUPPLIER_PAYMENT_TYPE_TABS = {
  supplierPaymentStatus: '1',
  history: '2'
};
export const SEARCH_COLUMN = {
  CustomerName: 'name',
  FabricId: 'generatedFabricId',
  GstNumber: 'gstNumber'
};

export const SEARCH_SUPPLIER_COLUMN = {
  SupplierName: 'name',
  FabricId: 'generatedFabricId'
};

export const SEARCH_FILTERS = [
  {
    filterName: 'Customer Name',
    filterText: SEARCH_COLUMN.CustomerName
  },
  {
    filterName: 'LFB-ID',
    filterText: SEARCH_COLUMN.FabricId
  }
];

export const SEARCH_FILTERS_CUSTOMER_LEDGER = [
  {
    filterName: 'Customer Name',
    filterText: SEARCH_COLUMN.CustomerName
  },
  {
    filterName: 'Gst Number',
    filterText: SEARCH_COLUMN.GstNumber
  }
];

export const SEARCH_SUPPLIER_FILTERS = [
  {
    filterName: 'Supplier Name',
    filterText: SEARCH_SUPPLIER_COLUMN.SupplierName
  },
  {
    filterName: 'LFB-ID',
    filterText: SEARCH_SUPPLIER_COLUMN.FabricId
  }
];
export const ORDER_TYPE_CASH = 1;
export const ORDER_TYPE_CREDIT = 2;

export const ORDER_TYPES = {
  [ORDER_TYPE_CASH]: 'Cash',
  [ORDER_TYPE_CREDIT]: 'Credit'
};

export const ORDER_TYPE_FILTERS = [
  {
    text: ORDER_TYPES[ORDER_TYPE_CASH],
    value: ORDER_TYPE_CASH
  },
  {
    text: ORDER_TYPES[ORDER_TYPE_CREDIT],
    value: ORDER_TYPE_CREDIT
  }
];

export const INVOICE_STATUS_PENDING = 1;
export const INVOICE_STATUS_GENERATED = 2;

export const INVOICE_STATUS_FILTERS = [
  {
    text: 'Pending',
    value: INVOICE_STATUS_PENDING
  },
  {
    text: 'Generated',
    value: INVOICE_STATUS_GENERATED
  }
];

export const ORDER_STATUS = {
  INITIATED: 1,
  NOT_INITIATED: 0
};
